import * as React from 'react';
import Stack from '@mui/joy/Stack';
import Sheet from '@mui/joy/Sheet';
import Typography from '@mui/joy/Typography';
import { Box, Chip, IconButton, Input } from '@mui/joy';
import List from '@mui/joy/List';
import RefreshIcon from '@mui/icons-material/Refresh';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ChatListItem from './ChatListItem';
import { toggleMessagesPane } from './utils';

export default function ChatsPane(props) {
  const {
    chats,
    number_of_unread_messages,
    setSelectedChat,
    selectedChatId,
    setSelectedChatId,
    handleRefresh,
  } = props;
  
  const [searchQuery, setSearchQuery] = React.useState('');
  
  const filteredChats = React.useMemo(() => {
    if (!searchQuery.trim()) {
      return chats;
    }
    
    const query = searchQuery.toLowerCase();
    return chats.filter(chat => {
      const userProfile = (chat.user_profile || '').toLowerCase();
      const userId = (chat.user_id || '').toString().toLowerCase();
      
      return userProfile.includes(query) || userId.includes(query);
    });
  }, [chats, searchQuery]);
  
  return (
    <Sheet
      sx={{
        borderRight: '1px solid',
        borderColor: 'divider',
        height: { sm: 'calc(80dvh - var(--Header-height))', md: '92dvh' },
        overflowY: 'auto',
      }}>
      <Stack
        direction="row"
        spacing={1}
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
          p: 2,
          pb: 1.5,
        }}>
        <Typography
          component="h1"
          endDecorator={
            <Chip
              variant="soft"
              color="primary"
              size="md"
              slotProps={{ root: { component: 'span' } }}>
              {number_of_unread_messages}
            </Chip>
          }
          sx={{
            fontSize: { xs: 'md', md: 'lg' },
            fontWeight: 'lg',
            mr: 'auto',
          }}>
          Mensajes
        </Typography>
        <IconButton
          variant="plain"
          aria-label="edit"
          color="neutral"
          size="sm"
          onClick={() => handleRefresh()}
          sx={{ display: { xs: 'none', sm: 'unset' } }}>
          <RefreshIcon />
        </IconButton>
        <IconButton
          variant="plain"
          aria-label="edit"
          color="neutral"
          size="sm"
          onClick={() => {
            toggleMessagesPane();
          }}
          sx={{ display: { sm: 'none' } }}>
          <CloseRoundedIcon />
        </IconButton>
      </Stack>
      <Box sx={{ px: 2, pb: 1.5 }}>
        <Input
          size="sm"
          startDecorator={<SearchRoundedIcon />}
          placeholder="Buscar"
          aria-label="Search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          slotProps={{
            input: {
              autoFocus: false,
            },
          }}
        />
      </Box>
      <List
        sx={{
          py: 0,
          '--ListItem-paddingY': '0.75rem',
          '--ListItem-paddingX': '1rem',
        }}>
        {filteredChats.length > 0 ? (
          filteredChats.map(chat => (
            <ChatListItem
              key={chat.id}
              {...chat}
              setSelectedChatId={setSelectedChatId}
              setSelectedChat={setSelectedChat}
              selectedChatId={selectedChatId}
            />
          ))
        ) : (
          <Box sx={{ p: 2, textAlign: 'center' }}>
            <Typography level="body-sm" color="neutral">
              No se encontraron resultados
            </Typography>
          </Box>
        )}
      </List>
    </Sheet>
  );
}
